/**
 * This code was generated by Builder.io.
 */
import { Button } from '@mui/material';
import React from 'react';
import ChevronLeftFilled from '@mui/icons-material/ChevronLeft';
import ChevronRightFilled from '@mui/icons-material/ChevronRight';
import Image from 'next/image';
type MultiStepLayoutHeaderProps = {
  leftButton?: boolean;
  rightButton?: boolean;
};

const MultiStepLayoutHeader = ({ leftButton, rightButton }: MultiStepLayoutHeaderProps) => {
  return (
    <header className="flex justify-center items-center px-4 lg:py-6 py-4 w-full bg-paper z-10 lg:h-[100px]">
      <div className="md:w-[136px]">
        {leftButton && (
          <Button
            size="large"
            variant="text"
            color="primary"
            className="flex-1 shrink my-auto w-full min-w-[240px] max-md:max-w-full"
          >
            <ChevronLeftFilled />
            <span className="hidden md:block">Indietro</span>
          </Button>
        )}
      </div>
      <Image
        loading="lazy"
        src="/assets/images/logotipo-white.svg"
        alt="Company logo"
        width={152} // Aggiunta della larghezza
        height={42}
        className="object-contain self-stretch my-auto aspect-[3.62] w-[152px]"
      />
      <div className="md:w-[136px]">
        {rightButton && (
          <Button
            size="large"
            variant="text"
            color="primary"
            className="flex-1 shrink my-auto w-full min-w-[240px] max-md:max-w-full"
          >
            <span className="hidden md:block">Avanti</span>
            <ChevronRightFilled />
          </Button>
        )}
      </div>
    </header>
  );
};

export default MultiStepLayoutHeader;
